import { connect, ConnectedProps } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { RootState } from '../../../store';
import { IDwelling } from '../../dwelling/reducers';
import * as Actions from '../actions';
import BuildingSheetDetails from '../components/BuildingSheetDetails';
import { IBuilding } from '../reducers';

const mapStateToProps = (state: RootState) => {
  const building: IBuilding = state.buildingReducer.building;
  const buildingDwellings: Array<IDwelling> = state.buildingReducer.buildingDwellings;
  const buildingDwellingsCount: number = state.buildingReducer.buildingDwellingsCount;

  return {
    building,
    buildingDwellings,
    buildingDwellingsCount
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    getBuilding: (id: string) => {
      return new Promise((resolve: any, reject: any) => {
        dispatch(Actions.getBuilding(resolve, reject, id));
      });
    },
    getBuildingDwellings: (page: number, buildingId: string) => {
      return new Promise((resolve: any, reject: any) => {
        dispatch(Actions.getBuildingDwellings(resolve, reject, page, buildingId));
      });
    }
  };
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type PropsFromReduxAppBuildingSheetDetails = ConnectedProps<typeof connector>;

export default withRouter(connector(BuildingSheetDetails));
